import { Link } from "react-router-dom";
import { SectionHead } from "./SectionHead";
import { ArticleGrid } from "@/pages/blog/ArticleCard";
import { ARTICLES } from "@/content/articles";

export const BlogTeaser = () => (
  <section id="blog" className="relative py-28 sm:py-36 bg-[#0F2317]" data-testid="blog-teaser-section">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
        <SectionHead dark eyebrow="Dal blog" lines={["Informarsi aiuta", "ad avere meno paura."]} />
        <Link to="/blog" className="self-start lg:self-auto rounded-full border border-[#FCFBF7]/25 text-[#FCFBF7] px-6 py-3 text-sm hover:bg-[#FCFBF7]/10 transition-colors" data-testid="blog-teaser-all-link">Tutti gli articoli</Link>
      </div>
      <div className="mt-14"><ArticleGrid items={ARTICLES.slice(0, 3)} dark /></div>
    </div>
  </section>
);
